const statusType = {
    PENDING: 'pending',
    PASSED: 'passed',
    FAILED: 'failed'
};

const statusReason = {
    DENIAL_CF: 'denial_cumulative_transaction_activity_frequency',
    DENIAL_FAILED_AUTH: 'denial_iauth_failed_too_recently',
    DENIAL_IP: 'denial_ip_flagging',
    BLOCKED: 'blocked',
    TECHNICAL: 'technical_failure'
};

export { statusType, statusReason };